interface Props {
  data: any[];
  /** Row number offset when the list is paged */
  startIndex?: number;
  emptyText?: string;
  onEdit: (loc: any) => void;
  onDelete: (id: string) => void;
}

export default function LocationTable({ data, startIndex = 0, emptyText, onEdit, onDelete }: Props) {
  return (
    <div className="table-responsive">
      <table className="table align-middle mb-0">
        <thead className="bg-light text-nowrap">
          <tr>
            <th className="ps-4">#</th>
            <th>LOCATION NAME</th>
            <th>LATITUDE</th>
            <th>LONGITUDE</th>
            <th>RADIUS (m)</th>
            <th className="text-end pe-4">ACTIONS</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 && (
            <tr>
              <td colSpan={6} className="text-center text-muted py-4">
                {emptyText ?? "No locations found. Add one above."}
              </td>
            </tr>
          )}
          {data.map((loc: any, i: number) => (
            <tr key={loc._id || i}>
              <td className="ps-4 text-muted">{startIndex + i + 1}</td>

              <td>
                <div className="fw-semibold">{loc.name}</div>
              </td>

              <td className="small text-muted">
                {loc.location?.coordinates?.[1]?.toFixed(5)}
              </td>

              <td className="small text-muted">
                {loc.location?.coordinates?.[0]?.toFixed(5)}
              </td>

              <td>
                <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2">
                  {loc.radius} m
                </span>
              </td>

              <td className="text-end pe-4">
                <button
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="Edit"
                  onClick={() => onEdit(loc)}
                >
                  <i className="bi bi-pencil" />
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  title="Delete"
                  onClick={() => {
                    if (window.confirm(`Delete "${loc.name}"?`)) {
                      onDelete(loc._id);
                    }
                  }}
                >
                  <i className="bi bi-trash" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
